<div fxLayout="column">
  <button mat-button mat-raised-button color="primary" (click)="updatePrices()">Aktualizuj ceny wg aktualnej marży</button>
  <button mat-button mat-raised-button color="primary" (click)="activateAuctions()">Publikuj wszystkie aukcje</button>
  <button mat-button mat-raised-button color="accent" (click)="deactivateAuctions()">Zakończ wszystkie aukcje</button>
  <button mat-button mat-raised-button color="accent" (click)="remofeDraftAuctions()">Usuń szkice aukcji z Allegro</button>
</div>

